<template>
  <div :id="'select-lemma' + idClass">
    <Select2 v-model="selected" @select="select($event)" :settings="selectConfig" ref="select2" tabindex="0" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Select2 from 'v-select2-component'
  import config from '@/config.js'

  export default {
    name: 'LemmaSelect',
    props: ['exclude', 'lemma', 'isRequired', 'idClass', 'isArticleEtymon', 'articleId', 'multiple'],
    components: {
      Select2
    },
    data(){
      return {
        lemmaObj: this.lemma,
        selected: null
      }
    },
    mounted() {
      if (this.lemma){
        let prefillLemma = this.lemma.constructor === Array ? this.lemma : [this.lemma]
        prefillLemma.forEach(lemma => {
          this.$refs.select2.select2.append(
            `<option selected value="${lemma.id}">${lemma.display}</option>`
          )
        })
        this.$refs.select2.select2.trigger('change')
      }
    },
    computed: {
      ...mapState({
          userSettings: state => state.user.settings,
          userSettingsPI: state => state.user.settingsPI,
      }),
      additionalData(){
        return {
          'dictionaries': this.userSettings.dictionaries
        }
      },
      selectConfig(){
        return {
          placeholder: "Select a lemma",
          allowClear: true,
          width: '100%',
          dropdownParent: "#select-lemma" + this.idClass,
          minimumInputLength: this.isRequired == true ? 3 : 1,
          multiple: this.multiple ?? false,

          ajax: {
            delay: 1400,
            url: config.apiUrl + '/lemmas/autocomplete',
            headers: config.apiHeaders,
            data: (params) => {
              const query = params.term || '';
              return {
                query: query,
                page: params.page || 1,
                additionalData: this.additionalData,
                exclude: this.exclude ? this.exclude : [],
                isArticleEtymon: this.isArticleEtymon,
                articleId: this.articleId
              }
            },
            processResults: (data) => {
              return {
                results: data.results.map(lemma => {
                  if (lemma.article) {
                    return {
                      id: lemma.id,
                      text: `${lemma.lemma} / ${lemma.article} [${lemma.dictionary}]`,
                      lemma: lemma
                    }
                  } else {
                    return {
                      id: lemma.id,
                      text: `${lemma.lemma}`,
                      lemma: lemma
                    }
                  }
                }),
                pagination: {
                  more: data.more
                }
              }
            }
          }
        }
      }
    },
    methods: {
      select(event){
        let lemma =  this.selected ? event.lemma : null
        this.lemmaObj = lemma
        this.$emit('select', lemma)
      }
    }
  }
</script>
